// extracted by mini-css-extract-plugin
export var separator = "separator2023-module--separator--094c3";